module.exports = __webpack_public_path__ + "img/score_logo.d13fb259.png";